(function () {
  window.console = window.console || {};
  window.console.log = window.console.log || function () {
  };
  window.console.debug = window.console.debug || window.console.log;
  window.console.info = window.console.info || window.console.log;
  window.console.warn = window.console.warn || window.console.log;
  window.console.error = window.console.error || window.console.log;
})();